import ApiService from '@/core/services/api.service';

export const ErrorSeverityService = {
  getAll(params = {}) {
    return ApiService.query(`v1/warranty/error-severities`, { params });
  },

  getById(id) {
    return ApiService.get(`v1/warranty/error-severities/${id}`);
  },

  create(data) {
    return ApiService.post('v1/warranty/error-severities', data);
  },

  update(id, data) {
    return ApiService.put(`v1/warranty/error-severities/${id}`, data);
  },

  delete(id) {
    return ApiService.delete(`v1/warranty/error-severities/${id}`);
  },

  updateActiveStatus(id, isActive) {
    return ApiService.patch(
      `v1/warranty/error-severities/${id}/active-status`,
      {
        isActive,
      },
    );
  },
};
